import Ads from './Ads';

export default Ads;